const STOP_WORDS = new Set([
  "a",
  "an",
  "the",
  "to",
  "of",
  "in",
  "on",
  "for",
  "is",
  "are",
  "do",
  "does",
  "i",
  "me",
  "can",
  "please",
  "and",
  "it",
  "be",
  "what",
  "whats",
]);

/**
 * A plural "s", but not a word whose singular still ends in s ("class", "classes").
 * "notices" becomes "notice"; "class" stays "class".
 */
export function stemWord(word: string): string {
  if (word.length > 4 && word.endsWith("es")) {
    const withoutEs = word.slice(0, -2);
    if (withoutEs.endsWith("s")) return withoutEs;
  }
  if (word.length > 3 && word.endsWith("s") && !word.endsWith("ss")) return word.slice(0, -1);
  return word;
}

/** Lowercased words without punctuation, stop words or a plural "s". */
export function significantWords(text: string): Set<string> {
  const words = text
    .toLowerCase()
    .replace(/[^a-z0-9\s]+/g, "")
    .split(/\s+/)
    .filter((w) => w && !STOP_WORDS.has(w))
    .map(stemWord);
  return new Set(words);
}
